var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1897_12948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1897_12948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51965 16.1155C7.81196 16.1155 6.36582 15.5232 5.18122 14.3386C3.99661 13.1539 3.4043 11.7078 3.4043 10.0001C3.4043 8.29243 3.99661 6.84628 5.18122 5.66167C6.36582 4.47707 7.81196 3.88477 9.51965 3.88477C11.2273 3.88477 12.6735 4.47707 13.8581 5.66167C15.0427 6.84628 15.635 8.29243 15.635 10.0001C15.635 10.7142 15.5151 11.3963 15.2754 12.0463C15.0356 12.6963 14.7158 13.2616 14.3158 13.7424L20.0696 19.4963C20.2081 19.6347 20.2789 19.8088 20.2821 20.0184C20.2853 20.228 20.2145 20.4052 20.0696 20.5501C19.9248 20.695 19.7491 20.7674 19.5427 20.7674C19.3363 20.7674 19.1607 20.695 19.0158 20.5501L13.2619 14.7962C12.7619 15.2091 12.1869 15.5321 11.5369 15.7655C10.8869 15.9988 10.2145 16.1155 9.51965 16.1155ZM9.51965 14.6155C10.8081 14.6155 11.8995 14.1684 12.7937 13.2742C13.6879 12.3799 14.135 11.2886 14.135 10.0001C14.135 8.71165 13.6879 7.6203 12.7937 6.72607C11.8995 5.83183 10.8081 5.38472 9.51965 5.38472C8.23118 5.38472 7.13983 5.83183 6.2456 6.72607C5.35138 7.6203 4.90427 8.71165 4.90427 10.0001C4.90427 11.2886 5.35138 12.3799 6.2456 13.2742C7.13983 14.1684 8.23118 14.6155 9.51965 14.6155Z",
    fill: "#343A40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2cd552f26692f128af5f27940c3ae1a7.svg";
export { ForwardRef as ReactComponent };